var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbox-window',{attrs:{"label":_vm.$translate('Tool')}},[_c('component-settings',{staticClass:"zoezi-edit-popover-settings"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }